import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import { useGetPatientInfo } from 'modules/report/hooks/usePatientInfo';

export const PieChartLabels = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const patientId = searchParams.get('patientId');
  const { data: patientInfo } = useGetPatientInfo(patientId);
  const { isPregnant } = patientInfo || {};

  const range = isPregnant
    ? ['120', '60 - 120', '60']
    : ['180', '70 - 180', '70'];
  const labels = [
    {
      label: `high ( > ${range[0]} )`,
      color: '#feb140'
    },
    {
      label: `In Range ( ${range[1]} )`,
      color: '#3bba4c'
    },
    {
      label: `Low ( < ${range[2]} )`,
      color: '#d81d5d'
    }
  ];

  return (
    <StyledPiechartLabel>
      <p className="point-in-range">Points in Range</p>
      <div className="labels">
        {labels.map((item) => (
          <div key={item.label}>
            <div className="square" style={{ background: item.color }} />
            <p className="text" style={{ color: item.color }}>
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </StyledPiechartLabel>
  );
};

const StyledPiechartLabel = styled.div`
  display: grid;
  .point-in-range {
    width: 100%;
    color: #4e4e4e;
    font-size: 12px;
    font-family: 'dana-bold';
    letter-spacing: 1px;
    text-align: center;
    padding-bottom: 24px;
  }
  .square {
    width: 18px;
    height: 18px;
    border-radius: 4px;
  }
  .text {
    margin: 0;
    font-size: 10px;
    font-weight: bold;
  }
  .labels {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .labels div {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-direction: row-reverse;
  }
  @media screen and (min-width: 1024px) {
    .labels div {
      gap: 28px;
    }
    .text {
      font-size: 20px;
    }
    .square {
      width: 32px;
      height: 32px;
    }
    .point-in-range {
      font-size: 20px;
    }
  }
`;
